<template>
  <div id="app">
    <HeaderMenu v-if="$route.path !== '/acessar'"/>
    <div v-if="mostraAvisoIndisponibilidadeBanco" class="alert alert-warning rounded-0 mb-0 text-center aviso-indisponibilidade-banco" role="alert">
      O banco responsável pela emissão das cobranças está temporariamente indisponível. <br>
      Abra um chamado com nosso financeiro pelo CHAT ONLINE diretamente pelo sistema ou volte mais tarde.
    </div>
    <router-view/>
    <div v-if="mostraAvisoIndisponibilidadeBanco" class="libera-pagamento-teste-wrapper">
      <button
        type="button"
        class="btn btn-dark btn-sm btn-libera-pagamento" style="background-color: transparent;"
        :class="{ 'btn-libera-pagamento--ativo': liberaPagamentoTeste }"
        @click="toggleLiberacaoPagamento"
        :title="liberaPagamentoTeste ? 'Bloquear pagamento novamente' : 'Liberar pagamento para teste'"
        aria-label="Liberar pagamento para teste"
      >
        <i class="bi" :class="liberaPagamentoTeste ? 'bi-eye-slash' : 'bi-eye'"></i>
      </button>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import HeaderMenu from '@/components/HeaderMenu.vue' 
import bl from '@/utilitarios/beforeLoad.js'

export default {
  components: {
    HeaderMenu
  },
  computed: {
    mostraAvisoIndisponibilidadeBanco() {
      return String(process.env.VUE_APP_MOSTRA_AVISO_BANCO).toLowerCase() === 'true';
    },
    liberaPagamentoTeste() {
      return this.$store.state.liberaPagamentoTeste;
    }
  },
  async beforeMount() {
    if (window.localStorage.getItem('usuarioLogado') !== null) {      
      let payload = (JSON.parse(window.localStorage.getItem('usuarioLogado')))   
      this.$store.commit('MUDAR_USUARIO_LOGADO', payload);
    } 

    const liberaPagamentoTeste = window.localStorage.getItem('rillpayLiberaPagamentoTeste') === 'true';
    this.$store.commit('MUDAR_LIBERACAO_PAGAMENTO_TESTE', liberaPagamentoTeste);

    let ret1 = await bl.carregaUsuarioLogado(this);
  },
  methods: {
    toggleLiberacaoPagamento() {
      const novoEstado = !this.liberaPagamentoTeste;
      this.$store.commit('MUDAR_LIBERACAO_PAGAMENTO_TESTE', novoEstado);
      window.localStorage.setItem('rillpayLiberaPagamentoTeste', novoEstado ? 'true' : 'false');
    }
  }
}
</script>
<style lang="scss">
.aviso-indisponibilidade-banco {
  font-weight: 600;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.libera-pagamento-teste-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 8px 10px 12px;
}

.btn-libera-pagamento {
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  opacity: 0.65;
}

.btn-libera-pagamento:hover,
.btn-libera-pagamento--ativo {
  opacity: 1;
}

.btn-libera-pagamento i {
  font-size: 0.85rem;
  line-height: 1;
}
</style>
